import axiosInstance from '../api/axiosInstance';
import { LoginRequestDto, LoginResponseDto } from '../dtos/AuthDto';

export class AuthRepository {
    static async login(data: LoginRequestDto): Promise<LoginResponseDto> {
        const response = await axiosInstance.post<LoginResponseDto>('/admin/login', data);
        return response.data;
    }

    static async getProfile(): Promise<any> {
        const response = await axiosInstance.get('/admin/profile');
        return response.data;
    }

    static async logout(): Promise<void> {
        await axiosInstance.post('/logout');
    }

    static async updateProfile(formData: FormData): Promise<any> {
        const response = await axiosInstance.post('/admin/profile/update', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    }
}
